const DEFAULT_GAP_PX = 8;

function visibleRect(documentRef, selector) {
  const element = documentRef?.querySelector?.(selector);
  if (!element) return null;
  const rect = element.getBoundingClientRect?.();
  return rect && rect.bottom > 0 ? rect : null;
}

export function focusedDocumentObstruction(documentRef = globalThis.document) {
  const rects = [
    visibleRect(documentRef, ".site-header"),
    visibleRect(documentRef, ".sticky-subnav"),
  ]
    .filter(Boolean)
    .sort((left, right) => left.top - right.top);
  let bottom = 0;
  for (const rect of rects) {
    if (rect.top <= bottom + DEFAULT_GAP_PX) bottom = Math.max(bottom, rect.bottom);
  }
  return bottom;
}

export function scrollFocusedDocumentTarget(
  target,
  {
    behavior = "auto",
    documentRef = globalThis.document,
    windowRef = globalThis.window,
  } = {}
) {
  if (!target || !windowRef?.scrollTo) return false;
  const rect = target.getBoundingClientRect?.();
  if (!rect) return false;

  const top = Math.max(0, Number(windowRef.scrollY || 0) + rect.top - DEFAULT_GAP_PX);
  windowRef.scrollTo({ top, behavior });

  const obstruction = focusedDocumentObstruction(documentRef);
  if (obstruction > 0) {
    windowRef.scrollTo({
      top: Math.max(0, top - obstruction),
      behavior,
    });
  }
  return true;
}
